// extracted by mini-css-extract-plugin
export var bgWrapper = "style-module--bgWrapper--60y3r";
export var divider = "style-module--divider--KS-+D";
export var dotsWrapper2 = "style-module--dotsWrapper2--Pib2F";
export var header = "style-module--header--xouLm";
export var highlight = "style-module--highlight--KUHgL";
export var img = "style-module--img--SmQ4G";
export var imgWrapper = "style-module--imgWrapper--lr63m";
export var otherProjects = "style-module--otherProjects--DPQlp";
export var otherWrapper = "style-module--otherWrapper--w57xf";
export var others = "style-module--others--A1Dq+";
export var place = "style-module--place--D6-x6";
export var project = "style-module--project--vIPLf";
export var projectTitle = "style-module--projectTitle--Ix8W7";
export var root = "style-module--root--483Ci";
export var summaryText = "style-module--summaryText--CBjhB";
export var text = "style-module--text--25OP2";
export var title = "style-module--title--fGC8p";
export var winners = "style-module--winners--QlUnc";
export var winnersImg = "style-module--winnersImg--ZiC2Z";
export var winnersTitle = "style-module--winnersTitle--vVxFz";